import { Phone, Mail, ArrowRight } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] w-full flex items-end overflow-hidden pt-24 pb-16 lg:pb-24"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_strength-club-3/artifacts/inmdkaxm_Screenshot%202026-04-14%20161752.png"
          alt="JerseyFit Barbell gym interior with blue training floor"
          className="w-full h-full object-cover"
          data-testid="hero-background-image"
        />
        {/* Dark gradient for contrast */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/70 to-[#050505]/50" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/80 via-[#050505]/30 to-transparent" />
        {/* Blue accent wash */}
        <div className="absolute -left-40 bottom-0 w-[700px] h-[700px] rounded-full bg-[#0055FF]/15 blur-[140px]" />
      </div>

      {/* Grid overlay */}
      <div className="absolute inset-0 grid-pattern opacity-40" />

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-9 rise">
            {/* Eyebrow */}
            <div className="inline-flex items-center gap-3 mb-8">
              <span className="h-px w-10 bg-[#0055FF]" />
              <span
                className="text-xs font-bold uppercase tracking-[0.3em] text-[#0055FF]"
                data-testid="hero-eyebrow"
              >
                Strength · Community · Family
              </span>
            </div>

            {/* Heading */}
            <h1
              data-testid="hero-heading"
              className="font-heading font-black tracking-tighter uppercase leading-[0.9] text-white text-5xl sm:text-7xl lg:text-[7.5rem]"
            >
              Lift Heavy.
              <br />
              <span className="text-gradient-blue">Lift Together.</span>
              <br />
              Be Welcomed.
            </h1>

            {/* Subcopy */}
            <p
              data-testid="hero-subheading"
              className="mt-8 max-w-2xl text-base sm:text-lg text-white/70 leading-relaxed font-medium"
            >
              JerseyFit Barbell is a home for every lifter — powerlifters,
              Olympic lifters, bodybuilders, and first-timers. Premium
              equipment, serious training, zero ego. Everyone who walks in is
              family.
            </p>

            {/* CTA row */}
            <div className="mt-10 flex flex-col sm:flex-row gap-4">
              <a
                href="tel:6185500625"
                data-testid="hero-call-btn"
                className="btn-primary px-7 py-4 font-heading font-bold uppercase tracking-wider text-sm inline-flex items-center justify-center gap-3 pulse-ring"
              >
                <Phone size={18} />
                Call (618) 550-0625
                <ArrowRight size={18} />
              </a>
              <a
                href="mailto:jfbarbell@gmail.com?subject=Membership%20Inquiry"
                data-testid="hero-email-btn"
                className="btn-secondary px-7 py-4 font-heading font-bold uppercase tracking-wider text-sm inline-flex items-center justify-center gap-3"
              >
                <Mail size={18} />
                Email jfbarbell@gmail.com
              </a>
            </div>

            {/* Side metric stack moved below */}
          </div>

          {/* Side metric stack */}
          <div className="hidden lg:flex lg:col-span-3 flex-col gap-4 rise">
            <div className="border border-white/10 bg-black/40 backdrop-blur-sm p-6">
              <div className="font-heading font-black text-4xl text-white">
                $50
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1">
                Per Month · Flat
              </div>
            </div>
            <div className="border border-white/10 bg-black/40 backdrop-blur-sm p-6">
              <div className="font-heading font-black text-4xl text-[#0055FF]">
                24/7
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1">
                All Lifters Welcome
              </div>
            </div>
            <div className="border border-white/10 bg-black/40 backdrop-blur-sm p-6">
              <div className="font-heading font-black text-4xl text-white">
                0
              </div>
              <div className="text-xs uppercase tracking-[0.2em] text-white/50 mt-1">
                Hidden Fees · Ever
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Blue scan line at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px] overflow-hidden z-10">
        <div className="w-1/3 h-full bg-gradient-to-r from-transparent via-[#0055FF] to-transparent scan-line" />
      </div>
    </section>
  );
}
